<template>
  <div class="right">
    <rightTop @data="getCreditDataFn"></rightTop>

    <div class="rightCenter">
      <div class="centerTit">公司简介</div>
      <div class="centerCon">
        <div @click="downloadFn(0)" class="excel" style="cursor: pointer;">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <table class="mailTable">
          <tr>
            <td class="column">公司名称：</td>
            <td>{{tableData.companyFullName}}</td>
          </tr>
          <tr>
            <td class="column">公司英文名称：</td>
            <td>{{tableData.companyEnName}}</td>
          </tr>
          <tr>
            <td class="column">公司简称：</td>
            <td>{{tableData.companyShortName}}</td>
          </tr>
          <tr>
            <td class="column">成立日期：</td>
            <td>{{tableData.establishmentDate}}</td>
          </tr>
          <tr>
            <td class="column">统一社会信用代码：</td>
            <td>{{tableData.uniformSocialCreditCode}}</td>
          </tr>
          <tr>
            <td class="column">机构类型：</td>
            <td>{{tableData.organizationType}}</td>
          </tr>
          <tr>
            <td class="column">组织形式：</td>
            <td>{{tableData.organizationForm}}</td>
          </tr>
          <tr>
            <td class="column">注册资本(元)：</td>
            <td>{{tableData.registerCapital}}</td>
          </tr>
          <tr>
            <td class="column">法人代表：</td>
            <td>{{tableData.legalPerson}}</td>
          </tr>
          <tr>
            <td class="column">董事长：</td>
            <td>{{tableData.boss}}</td>
          </tr>
          <tr>
            <td class="column">总经理：</td>
            <td>{{tableData.manager}}</td>
          </tr>
          <tr>
            <td class="column">所属地域：</td>
            <td>{{tableData.provinceCode}}</td>
          </tr>
          <tr>
            <td class="column">所属行业：</td>
            <td>{{tableData.csrcName}}</td>
          </tr>
          <!-- <tr>
            <td class="column">员工人数：</td>
            <td>{{tableData.personNum}}</td>
          </tr> -->
          <tr>
            <td class="column">公司电话：</td>
            <td>{{tableData.companyTelephone}}</td>
          </tr>
          <tr>
            <td class="column">公司传真：</td>
            <td>{{tableData.companyFax}}</td>
          </tr>
          <tr>
            <td class="column">公司电子邮箱：</td>
            <td>{{tableData.companyEmail}}</td>
          </tr>
          <tr>
            <td class="column">公司网址：</td>
            <td>{{tableData.companyUrl}}</td>
          </tr>
          <tr>
            <td class="column">邮政编码：</td>
            <td>{{tableData.postalCode}}</td>
          </tr>
          <tr>
            <td class="column">董事会秘书：</td>
            <td>{{tableData.secretaryBoardDirectors}}</td>
          </tr>
          <tr>
            <td class="column">董秘电话：</td>
            <td>{{tableData.secretariesTelephone}}</td>
          </tr>
          <tr>
            <td class="column">董秘传真：</td>
            <td>{{tableData.secretariesFax}}</td>
          </tr>
          <tr>
            <td class="column">董秘电子邮箱：</td>
            <td>{{tableData.secretariesEmail}}</td>
          </tr>
          <tr>
            <td class="column">信息披露网址：</td>
            <td>{{tableData.informationDisclosureWebsite}}</td>
          </tr>
          <tr>
            <td class="column">信息披露报纸：</td>
            <td>{{tableData.newsName}}</td>
          </tr>
          <tr>
            <td class="column">证券简称更名历史：</td>
            <td>{{tableData.nameRenamingHistory}}</td>
          </tr>
          <tr>
            <td class="column">注册地址：</td>
            <td>{{tableData.registeredAddress}}</td>
          </tr>
          <tr>
            <td class="column">办公地址：</td>
            <td>{{tableData.officeAddress}}</td>
          </tr>
          <tr>
            <td class="column">主营业务：</td>
            <td>{{tableData.main}}</td>
          </tr>
          <tr>
            <td class="column">公司简介：</td>
            <td>{{tableData.companyProfile}}</td>
          </tr>
          <tr>
            <td class="column">经营范围：</td>
            <td>{{tableData.businessScope}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
export default {
  data() {
    return {
      tableData:{},
      companyList:[],
      paramsData:{},//URL参数集合
    };
  },
  components:{
    rightTop
  },
  methods: {
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data)
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.fetchTable();//获取表格数据
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      //收入类型分类 0:按产品 1:按行业 2:按地域
      this.download(window.baseUrl + '/companyBasic/downCompanyProfile?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    fetchTable(){
        let _this = this;
        api.baseInfoTable(this.paramsData.stockCode,this.paramsData.enterpriseCode).then(res=>{
            let data = res.data;
            _this.tableData = data;
        })   
        console.log(this.$route.params.dbcode,"dbcode")
    }
  },
  created() {
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #dfecf7;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable,
.mailTable tr,
.mailTable tr td {
  border: 1px solid #08396a;
}
.mailTable {
  font-size: 14px;
  color: #4b4b4b;
  width: 100%;
  font-family: Microsoft YaHei;
}
.mailTable tr td {
  border: 1px solid #08396a;
  width: 80%;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  padding: 0 10px;
  color: #dfecf7;
}
.mailTable tr td.column {
  background-color: #375572;
  color: #dfecf7;
  font-size: 14px;
  font-weight: bold;
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/view/companyBaseInfo/index.vue